import React, { useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import './index.less'
import { Button as _Button, Input, Popover, Upload, message } from 'antd'
import {
  SearchOutlined,
  CameraOutlined,
  CloseOutlined,
  InboxOutlined,
  RightOutlined
} from '@ant-design/icons'
import { Header } from '@/components/Header'
import jiangshanqiusetu from '@/assets/images/jiangshanqiusetu.png'
import hanxizaiyeyantu from '@/assets/images/hanxizaiyeyantu.png'
import xieshengzhenqintu from '@/assets/images/xieshengzhenqintu.jpg'
import indexTitle from '@/assets/images/indexTitle.png'
import { searchMind, getIndexMetaData } from '@/server'
import { AI_PREDICTION_URL } from '@/server/apiConfig'
import { useState } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/css'
import 'swiper/css/effect-fade'
import 'swiper/css/pagination'
import { EffectFade, Pagination, Autoplay } from 'swiper'
import { useAppDispatch, useAppSelector } from '@/hooks'
import { setSearchKey, setImgFile, setImgsList } from '@/features/SetSearchKey'
import axios from 'axios'
import AdvancedSearch from '../AdvancedSearch'
import { current as _current } from '@reduxjs/toolkit'
const { Dragger } = Upload

export function OpenScreen() {
  // redux获取token
  const token = useAppSelector((state) => state.login.token)
  // 以图搜图功能模块显示
  const [cameraDisplay, setCameraDisplay] = useState<boolean>(false)
  // 搜索框内容数组
  const [searchList, setSearchList] = useState<any[]>([])
  // 输入框内容受控
  const [searchInputText, setSearchInputText] = useState('')
  // 实际键入内容
  const [exactInputText, setExactInputText] = useState('')
  // 当前选中的搜索条目idx
  const [activatedIndex, setActivatedIndex] = useState<number>(-1)
  // 搜索列表发生变化不选中任何条目
  useEffect(() => {
    setActivatedIndex(-1)
  }, [searchList])
  // 是否需要展示高亮条目
  const [activatedShowed, setActivatedShowed] = useState<boolean>(false)
  // redux配置
  const dispatch = useAppDispatch()
  // react-router配置
  const _navigate = useNavigate()
  // 存储定时器id
  const tickRef = useRef()
  // 作者数量、画作数量
  const [metaData, setMetaData] = useState<any>({})
  // 是否使用高级搜索
  const [useAdvancedSearch, setUseAdvancedSearch] = useState<boolean>(false)
  // 显示搜索框内容
  const [showInput, setShowInput] = useState<boolean>(false)
  // 初始化作者数量、画作数量
  useEffect(() => {
    getIndexMetaData(token).then((res) => setMetaData(res.data.content))
  }, [])
  /**
   * 柯里化函数，返回fun的防抖版本，即触发fun后delay时间段才生效，此时间段内再次触发则重新计时
   * @param fun: 功能函数
   * @param delay: 时间阈值
   * @returns function fun的防抖版本
   */
  function debounce(fun, delay) {
    return function (_args) {
      //@ts-ignore
      const that = this
      clearTimeout(tickRef.current)
      //@ts-ignore
      tickRef.current = setTimeout(function () {
        fun.call(that, _args)
      }, delay)
    }
  }
  // 获取搜索联想匹配的列表
  function ajax(content) {
    searchMind(
      {
        keyword: content
      },
      token
    ).then((res) => {
      setSearchList(res.data.content)
    })
  }
  // function ajax 的防抖版本
  const debounceAjax = debounce(ajax, 500)
  // 处理搜索框内容变化的回调
  const handleChange = (e: any) => {
    setExactInputText(e.target.value)
    setSearchInputText(e.target.value)
    if (e.target.value === '') {
      setSearchList([])
    } else {
      debounceAjax(e.target.value)
    }
  }

  // 点击列表某项的回调
  function handleClick(e) {
    dispatch(setSearchKey(e.target.innerText))
    // navigate("./searchResult")
    window.open('/searchResult')
  }
  // 回车列表某项的回调
  function handlePressEnter(e) {
    dispatch(setSearchKey(e.target.value))
    // navigate("./searchResult")
    window.open('/searchResult')
  }
  // 高级搜索的回调
  function handleAdvancedSearch(keyWord: string) {
    dispatch(setSearchKey(keyWord))
    // navigate("./searchResult")
    window.open('/searchResult')
    setUseAdvancedSearch(false)
  }
  // 处理搜索框上下按键高亮搜索条目
  // 只有上下按键改变输入框的值，hover不改变，setSearchInputText不再单独写出来
  function handleUpDown(e) {
    // 下
    if (e.keyCode === 40) {
      if (activatedIndex === searchList.length - 1) {
        setActivatedIndex(-1)
        setSearchInputText(exactInputText)
      } else if (activatedIndex === searchList.length) {
        setActivatedIndex(0)
        setSearchInputText(searchList[0])
      } else {
        setActivatedIndex(activatedIndex + 1)
        setSearchInputText(searchList[activatedIndex + 1])
      }
    }
    // 上
    else if (e.keyCode === 38) {
      if (activatedIndex === 0) {
        setActivatedIndex(searchList.length)
        setSearchInputText(exactInputText)
      } else if (activatedIndex === -1) {
        setActivatedIndex(searchList.length - 1)
        setSearchInputText(searchList[searchList.length - 1])
      } else {
        setActivatedIndex(activatedIndex - 1)
        setSearchInputText(searchList[activatedIndex - 1])
      }
    }
  }
  // 点击搜索框外部自动隐藏搜索列表
  useEffect(() => {
    const func = () => {
      // @ts-ignore
      document.getElementById('searchListContainer').style.display = 'none'
    }
    document.addEventListener('click', func)
    return () => {
      document.removeEventListener('click', func)
    }
  }, [])
  function handleSearchBoxClick(e) {
    // 禁止冒泡，阻止自动隐藏列表事件
    if (e.stopPropagation) {
      e.stopPropagation()
    } else {
      const event = e as any
      event.cancelBuble = true
    }
    // @ts-ignore
    document.getElementById('searchListContainer').style.display = 'block'
  }

  // 以图搜图 antd upload配置
  const props = {
    showUploadList: false,
    maxCount: 1,
    accept: 'image/png, image/jpeg, image/jpg',
    // 自定义上传方式
    customRequest: (info) => {
      // 设置上传最大容量为5MB
      const fileMaxSize = 5 << 20
      if (info.file.size <= fileMaxSize)
        axios
          .post(
            AI_PREDICTION_URL,
            { data: info.file },
            {
              headers: { 'Content-Type': 'multipart/form-data' }
            }
          )
          .then((res) => {
            dispatch(setSearchKey('*SEARCH-IMAGE*'))
            dispatch(setImgsList(res.data))
            dispatch(setImgFile(URL.createObjectURL(info.file)))
            window.open('./searchResult')
          })
          .catch((err) => {
            console.log(err)
          })
      else message.error('对不起, 上传图片容量不得超过5MB')
    }
  }
  return (
    <>
      <div className='open-screen-container'>
        <div className='index-header-container'>
          <Header />
        </div>
        <div className='mainland-container'>
          <div className='title-container'>
            <img src={indexTitle} alt='' />
          </div>
          <div className='subtitle-container'>
            共收录画家 {metaData.authorNum} 位，画作 {metaData.workNum} 幅
          </div>
          <div className='advanced-search-trigger'>
            <span
              onClick={() => {
                setUseAdvancedSearch(!useAdvancedSearch)
              }}
              style={{ cursor: 'pointer' }}
            >
              高级搜索
            </span>
            <RightOutlined />
          </div>

          <div className='search-bar-container'>
            {useAdvancedSearch ? (
              <AdvancedSearch handleSearchKeyWord={handleAdvancedSearch}></AdvancedSearch>
            ) : (
              <Popover
                placement='bottom'
                title=''
                content={searchInputText}
                open={showInput && searchInputText !== ''}
              >
                <Input
                  value={searchInputText}
                  placeholder='输入搜索关键字'
                  onChange={(e) => handleChange(e)}
                  onPressEnter={(e) => handlePressEnter(e)}
                  prefix={<SearchOutlined />}
                  suffix={
                    <CameraOutlined
                      onClick={() => setCameraDisplay(true)}
                      style={{ display: cameraDisplay ? 'none' : 'block' }}
                    />
                  }
                  bordered={false}
                  onClick={(e) => handleSearchBoxClick(e)}
                  onKeyDown={(e) => {
                    setActivatedShowed(true)
                    handleUpDown(e)
                  }}
                  onMouseOver={() => {
                    setShowInput(true)
                  }}
                  onMouseOut={() => {
                    setShowInput(false)
                  }}
                  autoComplete='off'
                  style={{
                    width: '100%',
                    height: '100%',
                    backgroundColor: '#FFFFFF',
                    borderRadius: '0px',
                    color: '#725C2A',
                    fontSize: '20px'
                  }}
                />
              </Popover>
            )}

            <div
              className='search-item-container'
              id='searchListContainer'
              onMouseEnter={() => setActivatedShowed(true)}
              onMouseLeave={() => setActivatedShowed(false)}
            >
              {searchList.map((d, i) => (
                <div
                  className={
                    i === activatedIndex && activatedShowed
                      ? 'search-item search-item-activated'
                      : 'search-item'
                  }
                  onClick={(e) => handleClick(e)}
                  onMouseOver={() => {
                    setActivatedIndex(i)
                  }}
                  style={{ display: cameraDisplay === false ? 'block' : 'none' }}
                >
                  {d}
                </div>
              ))}
            </div>
            <div
              className='upload-container'
              style={{ display: cameraDisplay === true ? 'block' : 'none' }}
            >
              <Dragger {...props}>
                <p className='ant-upload-drag-icon'>
                  <InboxOutlined style={{ color: '#725c2a' }} />
                </p>
                <p className='ant-upload-text' style={{ fontSize: '20px' }}>
                  拖拽图片到这里或点击上传
                </p>
                <p className='ant-upload-text' style={{ fontSize: '20px' }}>
                  以图搜图
                </p>
              </Dragger>
              <CloseOutlined
                className='close-search-image-button'
                onClick={(e) => {
                  //@ts-ignore
                  if (e.stopPropagation) {
                    e.stopPropagation()
                  } else {
                    const event = e as any
                    event.cancelBuble = true
                  }
                  setCameraDisplay(false)
                }}
              />
            </div>
          </div>
        </div>
        <div className='swiper-container'>
          <Swiper
            loop={true}
            spaceBetween={30}
            effect={'fade'}
            pagination={{
              clickable: true,
              clickableClass: 'my-pagination-clickable'
            }}
            autoplay={{
              delay: 5000,
              pauseOnMouseEnter: false
            }}
            modules={[EffectFade, Pagination, Autoplay]}
            className='mySwiper'
          >
            <SwiperSlide>
              <img src={jiangshanqiusetu} />
            </SwiperSlide>
            <SwiperSlide>
              <img src={hanxizaiyeyantu} />
            </SwiperSlide>
            <SwiperSlide>
              <img src={xieshengzhenqintu} />
            </SwiperSlide>
          </Swiper>
        </div>
      </div>
    </>
  )
}
